export const LAST_REPORT = 'LAST_REPORT';
export const MAINTENANCES_LAST_REPORT = 'MAINTENANCES_LAST_REPORT';
export const UPDATE_MAINTENANCES_LAST_REPORT = 'UPDATE_MAINTENANCES_LAST_REPORT';
export const CLEAR_SESSION = 'CLEAR_SESSION';
export const CLEAN_REDUCER = 'CLEAN_REDUCER';
export const LAST_EVENTS = 'LAST_EVENTS';
export const LAST_GEOFENCE_EVENTS = 'LAST_GEOFENCE_EVENTS';
